module.exports = function(data) {
var __t, __p = '';
__p += '<div class="grid-stack-item-content">\n    <div class="header drag-grip widgetTitle"></div>\n    <div class="content"></div>\n</div>\n';
return __p
}